// src/utils/imglazy.js
export default {
  install(Vue) {
    Vue.directive('img-lazy', {
      bind(el, binding) {
        // 设置占位图片
        el.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';

        // 创建新的图片对象进行预加载
        const img = new Image();
        img.onload = () => {
          if (el) {
            el.src = binding.value;
          }
        };
        img.onerror = () => {
          // 加载失败时使用原始图片
          if (el) {
            el.src = binding.value;
          }
        };
        img.src = binding.value;
      },

      update(el, binding) {
        if (binding.value !== binding.oldValue) {
          const img = new Image();
          img.onload = () => {
            if (el) {
              el.src = binding.value;
            }
          };
          img.onerror = () => {
            if (el) {
              el.src = binding.value;
            }
          };
          img.src = binding.value;
        }
      }
    });
  }
}
